'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _v = require('uuid/v1');

var _v2 = _interopRequireDefault(_v);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identitySelector = function identitySelector(_ref) {
  var user = _ref.user;

  var anonymousId = _reactCookie2.default.load('ajs_anonymous_id') ? JSON.parse(_reactCookie2.default.load('ajs_anonymous_id')) : (0, _v2.default)();
  var accessToken = _reactCookie2.default.load('access_token');

  var id = user.details ? user.details._id : anonymousId;
  if (!id) {
    return { id: 'unidentified' };
  }

  var idDoc = {
    id: id,
    anonymousId: anonymousId,
    entitlements: user.entitlements || null,
    identify: !anonymousId && !accessToken,
    type: user.details ? 'logged_in' : 'anonymous'
  };

  return idDoc;
};

exports.default = identitySelector;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/features/identity.js
// module id = 742
// module chunks = 10